import * as ACTIONTYPE from '../constants/actiontypes'

const iniitialState = {
  data: null,
  isVisible: false,
}
export default function (state = iniitialState, action) {
  switch (action.type) {
    case ACTIONTYPE.ADD_WIDGET_DATA:
      return {
        ...state,
        data: action.widgetData,
      };
    case ACTIONTYPE.SHOW_WIDGET:
      return {
        ...state,
        isVisible: true,
      };
    case ACTIONTYPE.HIDE_WIDGET:
      return {
        ...state,
        isVisible: false,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/WidgetReducer.js